import { FORM_SUBMITTED } from './constants';

/**
 * FORM_SUBMITTED action definition
 *
 * @return {Object}       FORM_SUBMITTED action definition
 */
export function formSubmitted(formId, fields, isValid, error) {
  return {
    type: FORM_SUBMITTED,
    formId,
    fields,
    isValid,
    error,
  };
}
